import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';

// ── Ana Menü ──
import Dashboard from './pages/Dashboard';
import LiveMap from './pages/LiveMap';
import Analytics from './pages/Analytics';

// ── Kullanıcı Yönetimi ──
import Users from './pages/Users';
import Families from './pages/Families';
import Subscriptions from './pages/Subscriptions';
import UserStatusManagement from './pages/UserStatusManagement';
import DeviceManagement from './pages/DeviceManagement';
import LocationPushStatus from './pages/LocationPushStatus';
import SupportInbox from './pages/SupportInbox';
import SessionManagement from './pages/SessionManagement';
import PasswordResetManagement from './pages/PasswordResetManagement';

// ── Konum & Harita ──
import Places from './pages/Places';
import POIManagement from './pages/POIManagement';
import TripManagement from './pages/TripManagement';
import RouteManagement from './pages/RouteManagement';
import LocationRequestManagement from './pages/LocationRequestManagement';
import LocationHistoryManagement from './pages/LocationHistoryManagement';
import ParkingManagement from './pages/ParkingManagement';

// ── Güvenlik ──
import VerificationManagement from './pages/VerificationManagement';
import DrivingManagement from './pages/DrivingManagement';
import Emergencies from './pages/Emergencies';
import SOSContactManagement from './pages/SOSContactManagement';
import ArrivalCheckManagement from './pages/ArrivalCheckManagement';

// ── İçerik ──
import StoryManagement from './pages/StoryManagement';
import StoryReplyManagement from './pages/StoryReplyManagement';
import MusicManagement from './pages/MusicManagement';
import CMSManagement from './pages/CMSManagement';

// ── İletişim ──
import Messages from './pages/Messages';
import NotificationManagement from './pages/NotificationManagement';
import Broadcast from './pages/Broadcast';
import FeedbackManagement from './pages/FeedbackManagement';

// ── Veri & Raporlar ──
import WeeklySummaryManagement from './pages/WeeklySummaryManagement';
import WeatherAlertManagement from './pages/WeatherAlertManagement';
import CrashReports from './pages/CrashReports';
import ActivityLogs from './pages/ActivityLogs';

// ── Ayarlar & Tercihler ──
import NotificationPrefManagement from './pages/NotificationPrefManagement';
import UserPrefManagement from './pages/UserPrefManagement';
import PrivacySettingsManagement from './pages/PrivacySettingsManagement';
import Settings from './pages/Settings';

// ── Sistem ──
import ApiStatus from './pages/ApiStatus';
import WebsocketMonitoring from './pages/WebsocketMonitoring';
import ServerManagement from './pages/ServerManagement';
import Backup from './pages/Backup';
import FeatureStatus from './pages/FeatureStatus';
import AdminSessions from './pages/AdminSessions';

// ── Email ──
import EmailManagement from './pages/EmailManagement';

// ── Profil ──
import Profile from './pages/Profile';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<Layout />}>
              {/* Ana Menü */}
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="live-map" element={<LiveMap />} />
              <Route path="analytics" element={<Analytics />} />

              {/* Kullanıcı Yönetimi */}
              <Route path="users" element={<Users />} />
              <Route path="families" element={<Families />} />
              <Route path="subscriptions" element={<Subscriptions />} />
              <Route path="user-statuses" element={<UserStatusManagement />} />
              <Route path="devices" element={<DeviceManagement />} />
              <Route path="location-push" element={<LocationPushStatus />} />
              <Route path="support" element={<SupportInbox />} />
              <Route path="sessions" element={<SessionManagement />} />
              <Route path="password-resets" element={<PasswordResetManagement />} />

              {/* Konum & Harita */}
              <Route path="places" element={<Places />} />
              <Route path="poi" element={<POIManagement />} />
              <Route path="trips" element={<TripManagement />} />
              <Route path="routes" element={<RouteManagement />} />
              <Route path="location-requests" element={<LocationRequestManagement />} />
              <Route path="location-history" element={<LocationHistoryManagement />} />
              <Route path="parking" element={<ParkingManagement />} />

              {/* Güvenlik */}
              <Route path="verification" element={<VerificationManagement />} />
              <Route path="driving" element={<DrivingManagement />} />
              <Route path="emergencies" element={<Emergencies />} />
              <Route path="sos-contacts" element={<SOSContactManagement />} />
              <Route path="arrival-checks" element={<ArrivalCheckManagement />} />

              {/* İçerik */}
              <Route path="stories" element={<StoryManagement />} />
              <Route path="story-replies" element={<StoryReplyManagement />} />
              <Route path="music" element={<MusicManagement />} />
              <Route path="cms" element={<CMSManagement />} />

              {/* İletişim */}
              <Route path="messages" element={<Messages />} />
              <Route path="notifications" element={<NotificationManagement />} />
              <Route path="broadcast" element={<Broadcast />} />
              <Route path="feedback" element={<FeedbackManagement />} />

              {/* Veri & Raporlar */}
              <Route path="weekly-summaries" element={<WeeklySummaryManagement />} />
              <Route path="weather-alerts" element={<WeatherAlertManagement />} />
              <Route path="crash-reports" element={<CrashReports />} />
              <Route path="activity-logs" element={<ActivityLogs />} />

              {/* Ayarlar & Tercihler */}
              <Route path="notification-preferences" element={<NotificationPrefManagement />} />
              <Route path="user-preferences" element={<UserPrefManagement />} />
              <Route path="privacy-settings" element={<PrivacySettingsManagement />} />
              <Route path="settings" element={<Settings />} />

              {/* Sistem */}
              <Route path="api-status" element={<ApiStatus />} />
              <Route path="websocket" element={<WebsocketMonitoring />} />
              <Route path="server" element={<ServerManagement />} />
              <Route path="backup" element={<Backup />} />
              <Route path="feature-status" element={<FeatureStatus />} />
              <Route path="admin-sessions" element={<AdminSessions />} />

              {/* Email */}
              <Route path="email" element={<EmailManagement />} />

              {/* Profil */}
              <Route path="profile" element={<Profile />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
